export const localeText = {
  uk: {
    address: 'м. Львів, вул. Богдана Хмельницького, 114а',
    language: 'МОВНІ КУРСИ',
    about: 'ПРО НАС',
    bloh: 'БЛОГ',
    news: 'Новини, статті, подкасти з гостями в блозі',
    privacyPolicy: 'Політика конфіденційності',
    publicOffer: 'Публічна оферта',
    formError: 'Форма не відправлена. Спробуйте, будь ласка, ще раз.',
    formSuccsess: 'Форма успішно надіслана!',
    name: "Ім'я",
    lastName: 'Прізвище',
    fullName: 'Ваше ім’я та прізвище',
    phone: 'Телефон',
    whenCalling: 'Коли вам зателефонувати?',
    nameRequired: "Ім'я є обов'язковим",
    nameTooLong: "Ім'я занадто довге",
    phoneRequired: "Телефон є обов'язковим",
    phoneTooLong: 'Телефон занадто довгий',
    phoneWrong: 'Невірний формат номера телефону',
    send: 'Надіслати',
    sending: 'Надсилання...',
    whatPosition: 'Яка посада вас цікавить?',
    login: 'Увійти',
    retail: 'Роздріб',
    level: 'Рівень',
    month: 'Місяць',
    threeMonth: '3 місцяі',
    halfYear: 'пів року',
    year: 'Рік',
    uahMonth: 'грн/місяць',
    uahLesson: 'грн/урок',
    uanLessonOnePerson: 'грн/урок (з однієї людини)',
    mixType: 'Заняття змішаного типу (теоретичні, практичні та індивідуальні)',
    individual: 'Індивідуальні',
    pair: 'Парні',
    group: 'Корпоративні',
    selectPackage: 'обрати пакет',
    hide: 'Сховати',
    showMore: 'Показати більше',
    watchPackage: 'Переглянути пакет',
    collapse: 'Згорнути',
    signUp: 'Записатися',
    close: 'Закрити',
    needConsultation: 'Бажаєте отримати консультацію?',
    leaveRequest: 'Залиште заявку і наш менеджер вам зателефонує',
  },
  en: {
    address: 'Lviv, 114a Bohdana Khmelnytskoho St.',
    language: 'LANGUAGE COURSES',
    about: 'ABOUT US',
    bloh: 'BLOG',
    news: 'News, articles, podcasts with guests in the blog',
    privacyPolicy: 'Privacy Policy',
    publicOffer: 'Public Offer',
    formError: 'Form not submitted. Please try again.',
    formSuccsess: 'Form submitted successfully!',
    name: 'First Name',
    lastName: 'Last Name',
    fullName: 'Your First and Last Name',
    phone: 'Phone',
    whenCalling: 'When should we call you?',
    nameRequired: 'Name is required',
    nameTooLong: 'Name is too long',
    phoneRequired: 'Phone is required',
    phoneTooLong: 'Phone number is too long',
    phoneWrong: 'Invalid phone number format',
    send: 'Send',
    sending: 'Sending...',
    whatPosition: 'What position are you interested in?',
    login: 'Log In',
    retail: 'Retail',
    level: 'Level',
    month: 'Month',
    threeMonth: '3 months',
    halfYear: 'Half Year',
    year: 'Year',
    uahMonth: 'UAH/month',
    uahLesson: 'UAH/lesson',
    uanLessonOnePerson: 'UAH/lesson (per person)',
    mixType: 'Mixed type classes (theoretical, practical, and individual)',
    individual: 'Individual',
    pair: 'Paired',
    group: 'Corporate',
    selectPackage: 'Select Package',
    hide: 'Hide',
    showMore: 'Show more',
    watchPackage: 'View package',
    collapse: 'Collapse',
    signUp: 'Sign up',
    close: 'Close',
    needConsultation: 'Would you like to get a consultation?',
    leaveRequest: 'Leave a request and our manager will call you back',
  },
  pl: {
    address: 'Lwów, ul. Bohdana Chmielnickiego 114a',
    language: 'KURSY JĘZYKOWE',
    about: 'O NAS',
    bloh: 'BLOG',
    news: 'Aktualności, artykuły, podcasty z gośćmi na blogu',
    privacyPolicy: 'Polityka prywatności',
    publicOffer: 'Oferta publiczna',
    formError: 'Formularz nie został wysłany. Spróbuj ponownie.',
    formSuccsess: 'Formularz został pomyślnie wysłany!',
    name: 'Imię',
    lastName: 'Nazwisko',
    fullName: 'Twoje imię i nazwisko',
    phone: 'Telefon',
    whenCalling: 'Kiedy do Ciebie zadzwonić?',
    nameRequired: 'Imię jest wymagane',
    nameTooLong: 'Imię jest za długie',
    phoneRequired: 'Telefon jest wymagany',
    phoneTooLong: 'Numer telefonu jest za długi',
    phoneWrong: 'Nieprawidłowy format numeru telefonu',
    send: 'Wyślij',
    sending: 'Wysyłanie...',
    whatPosition: 'Jakie stanowisko Cię interesuje?',
    login: 'Zaloguj się',
    retail: 'Detaliczny',
    level: 'Poziom',
    month: 'Miesiąc',
    threeMonth: '3 miesiące',
    halfYear: 'Pół roku',
    year: 'Rok',
    uahMonth: 'UAH/miesiąc',
    uahLesson: 'UAH/lekcja',
    uanLessonOnePerson: 'UAH/lekcja (na osobę)',
    mixType: 'Zajęcia mieszane (teoretyczne, praktyczne i indywidualne)',
    individual: 'Indywidualne',
    pair: 'Parowe',
    group: 'Korporacyjne',
    selectPackage: 'Wybierz pakiet',
    hide: 'Ukryj',
    showMore: 'Pokaż więcej',
    watchPackage: 'Zobacz pakiet',
    collapse: 'Zwiń',
    signUp: 'Zapisz się',
    close: 'Zamknij',
    needConsultation: 'Chcesz uzyskać konsultację?',
    leaveRequest: 'Zostaw zgłoszenie, a nasz menedżer do Ciebie oddzwoni',
  },
};

export const localizedMenu = {
  uk: {
    home: 'Головна',
    price: 'Ціна',
    language: 'Мовні курси',
    preschool: 'Дошкільна підготовка',
    primary_school: 'Початкова школа',
    middle_high_school: 'Середня та старша школа',
    camps: 'Табори',
    nmt_prep: 'Підготовка до НМТ',
    admission: 'Все про вступ',
    abroad_edu: 'Навчання за кордоном',
    internship: 'Стажування в Україні',
    exchange_program: 'Програма обміну',
    grants: 'Гранти та стипендії',
    english: 'Англійська мова',
    english_kids: 'Англійська для дітей',
    english_group: 'Корпоративне навчання',
    english_individual: 'Індивідуальне навчання',
    english_tests: 'Підготовка до тестів',
    toefl: 'Підготовка до TOEFL',
    ielts: 'Підготовка до IELTS',
    toeic: 'Підготовка до TOEIC',
    cambridge: 'Підготовка до Cambridge ESOL',
    german: 'Німецька мова',
    german_kids: 'Німецька для дітей',
    german_group: 'Корпоративне навчання',
    german_individual: 'Індивідуальне навчання',
    german_tests: 'Підготовка до тестів',
    polish: 'Польська мова',
    polish_kids: 'Польська для дітей',
    polish_group: 'Корпоративне навчання',
    polish_individual: 'Індивідуальне навчання',
    polish_tests: 'Підготовка до тестів',
    polish_prep: 'Підготовчі курси B2',
    evi_prep: 'Підготовка до ЄВІ',
    about_us: 'Про нас',
    what_is_ap: 'Що таке AP Education?',
    career: 'Ваша кар’єра з нами',
    partner: 'Стань партнером!',
    cooperation: 'Запрошуємо до співпраці',
    blog: 'Блог',
    contacts: 'Контакти',
    prices: 'Ціни',
  },
  en: {
    home: 'Home',
    price: 'Price',
    language: 'Language Courses',
    preschool: 'Preschool preparation',
    primary_school: 'Primary school',
    middle_high_school: 'Middle and high school',
    camps: 'Camps',
    nmt_prep: 'Preparation for NMT',
    admission: 'All about admission',
    abroad_edu: 'Studying abroad',
    internship: 'Internship in Ukraine',
    exchange_program: 'Exchange program',
    grants: 'Grants and scholarships',
    english: 'English language',
    english_kids: 'English for kids',
    english_group: 'Group learning',
    english_individual: 'Individual learning',
    english_tests: 'Test preparation',
    toefl: 'TOEFL preparation',
    ielts: 'IELTS preparation',
    toeic: 'TOEIC preparation',
    cambridge: 'LanguageCert ESOL preparation',
    german: 'German language',
    german_kids: 'German for kids',
    german_group: 'Corporate learning',
    german_individual: 'Individual learning',
    german_tests: 'Test preparation',
    polish: 'Polish language',
    polish_kids: 'Polish for kids',
    polish_group: 'Corporate learning',
    polish_individual: 'Individual learning',
    polish_tests: 'Test preparation',
    polish_prep: 'B2 preparatory course',
    evi_prep: 'Preparation for EVI',
    about_us: 'About us',
    what_is_ap: 'What is AP Education?',
    career: 'Your career with us',
    partner: 'Become a partner!',
    cooperation: 'Join our cooperation',
    blog: 'Blog',
    contacts: 'Contacts',
    prices: 'Prices',
  },
  pl: {
    home: 'Strona główna',
    price: 'Cena',
    language: 'Kursy językowe',
    preschool: 'Przygotowanie przedszkolne',
    primary_school: 'Szkoła podstawowa',
    middle_high_school: 'Szkoła średnia i liceum',
    camps: 'Obozy',
    nmt_prep: 'Przygotowanie do NMT',
    admission: 'Wszystko o rekrutacji',
    abroad_edu: 'Nauka za granicą',
    internship: 'Staże na Ukrainie',
    exchange_program: 'Program wymiany',
    grants: 'Granty i stypendia',
    english: 'Język angielski',
    english_kids: 'Angielski dla dzieci',
    english_group: 'Szkolenia korporacyjne',
    english_individual: 'Nauka indywidualna',
    english_tests: 'Przygotowanie do testów',
    toefl: 'Przygotowanie do TOEFL',
    ielts: 'Przygotowanie do IELTS',
    toeic: 'Przygotowanie do TOEIC',
    cambridge: 'Przygotowanie do Cambridge ESOL',
    german: 'Język niemiecki',
    german_kids: 'Niemiecki dla dzieci',
    german_group: 'Szkolenia korporacyjne',
    german_individual: 'Nauka indywidualna',
    german_tests: 'Przygotowanie do testów',
    polish: 'Język polski',
    polish_kids: 'Polski dla dzieci',
    polish_group: 'Szkolenia korporacyjne',
    polish_individual: 'Nauka indywidualna',
    polish_tests: 'Przygotowanie do testów',
    polish_prep: 'Kurs przygotowawczy B2',
    evi_prep: 'Przygotowanie do EVI',
    about_us: 'O nas',
    what_is_ap: 'Czym jest AP Education?',
    career: 'Twoja kariera z nami',
    partner: 'Zostań partnerem!',
    cooperation: 'Zapraszamy do współpracy',
    blog: 'Blog',
    contacts: 'Kontakt',
    prices: 'Cennik',
  },
};

const defaultMenuTitle = [
  {
    id: 1,
    name: 'Головна',
    href: '/',
  },
  {
    id: 2,
    name: 'AP School',
    href: '/school',
    priceName: 'Ціна',
    hrefPrice: '/school/#price',
    color: 'violet' as 'violet' | 'blue' | 'green' | undefined,
    submenu: [
      {
        name: 'Дошкільна підготовка',
        href: '/school/doshkilna-osvita',
        subtitle: [],
      },
      {
        name: 'Початкова школа',
        href: '/school/pochatkova-shkola',
        subtitle: [],
      },
      {
        name: 'Середня та старша школа',
        href: '/school/serednia-starsha-shkola',
        subtitle: [],
      },
      {
        name: 'Табори',
        href: '/school/camp',
        subtitle: [],
      },
      {
        name: 'Підготовка до НМТ',
        href: '/school/pidgotovka-do-nmt',
        subtitle: [],
      },
    ],
  },
  {
    id: 3,
    name: 'AP University',
    href: '/university',
    priceName: 'Ціна',
    hrefPrice: '/university/#price',
    color: 'blue' as 'violet' | 'blue' | 'green' | undefined,
    submenu: [
      {
        name: 'Все про вступ',
        href: '/university/vstup',
        subtitle: [],
      },
      {
        name: 'Навчання за кордоном',
        href: '/university/abroad-education',
        subtitle: [],
      },
      {
        name: 'Стажування в Україні',
        href: '/university/stazhuvannia',
        subtitle: [],
      },
      {
        name: 'Програма обміну',
        href: '/university/programy-obminu',
        subtitle: [],
      },
      {
        name: 'Гранти та стипендії',
        href: '/university/grants-and-schoolarships',
        subtitle: [],
      },
    ],
  },
  {
    id: 4,
    name: 'Мовні курси',
    href: '/movni-kursy',
    priceName: 'Ціна',
    hrefPrice: '/price',
    color: 'green' as 'violet' | 'blue' | 'green' | undefined,
    submenu: [
      {
        name: 'Англійська мова',
        href: '/movni-kursy/english',
        subtitle: [
          {
            name: 'Англійська для дітей',
            href: '/movni-kursy/english/kids',
          },
          {
            name: 'Групове навчання',
            href: '/movni-kursy/english/grupove-navchannia',
          },
          {
            name: 'Індивідуальне навчання',
            href: '/movni-kursy/english/indyvidualne-navchannia',
          },
          {
            name: 'Підготовка до тестів',
            href: '/movni-kursy/english/tests',
          },
          {
            name: 'Підготовка до TOEFL',
            href: '/movni-kursy/english/toefl',
          },
          {
            name: 'Підготовка до IELTS',
            href: '/movni-kursy/english/ielts',
          },
          {
            name: 'Підготовка до TOEIC',
            href: '/movni-kursy/english/toeic',
          },
          {
            name: 'Підготовка до Cambridge ESOL',
            href: '/movni-kursy/english/languagecert-esol',
          },
        ],
      },
      {
        name: 'Німецька мова',
        href: '/movni-kursy/deutsch',
        subtitle: [
          {
            name: 'Німецька для дітей',
            href: '/movni-kursy/deutsch/kids',
          },
          {
            name: 'Групове навчання',
            href: '/movni-kursy/deutsch/grupove-navchannia',
          },
          {
            name: 'Індивідуальне навчання',
            href: '/movni-kursy/deutsch/indyvidualne-navchannia',
          },
          {
            name: 'Підготовка до тестів',
            href: '/movni-kursy/deutsch/tests',
          },
        ],
      },
      {
        name: 'Польська мова',
        href: '/movni-kursy/polski',
        subtitle: [
          {
            name: 'Польська для дітей',
            href: '/movni-kursy/polski/kids',
          },
          {
            name: 'Групове навчання',
            href: '/movni-kursy/polski/grupove-navchannia',
          },
          {
            name: 'Індивідуальне навчання',
            href: '/movni-kursy/polski/indyvidualne-navchannia',
          },
          {
            name: 'Підготовка до тестів',
            href: '/movni-kursy/polski/tests',
          },
        ],
      },
      {
        name: 'Підготовка до ЄВІ',
        href: '/movni-kursy/evi',
        subtitle: [],
      },
    ],
  },
  {
    id: 5,
    name: 'Про нас',
    href: '/about-us',
    color: 'green' as 'violet' | 'blue' | 'green' | undefined,
    submenu: [
      {
        name: 'Що таке AP Education?',
        href: '/about-us/shcho-take-ap-education',
        subtitle: [],
      },
      {
        name: 'Ваша кар’єра з нами',
        href: '/about-us/kariera',
        subtitle: [],
      },
      {
        name: 'Стань партнером!',
        href: '/about-us/stan-partnerom',
        subtitle: [],
      },
      {
        name: 'Запрошуємо до співпраці',
        href: '/about-us/spivpratsia',
        subtitle: [],
      },
      {
        name: 'Блог',
        href: 'https://blog.ap.education/',
        subtitle: [],
      },
    ],
  },
  {
    id: 6,
    name: 'Контакти',
    href: '/kontakty',
  },
  {
    id: 7,
    name: 'Ціни',
    href: '/price',
  },
];
